import React from 'react'
import styles from './Button.module.scss'

const Button = props => {
  const { href, children } = props
  return (<a href={href} className={['btn', styles.container].join(' ')}>{children}</a>)
}

export default Button
